<template>
    <div class="reseller-login">
        <div class="container">
            <div class="row justify-center">
                <div class="md:w-1/2 lg:w-5/12 w-full">
                    <div class="lg:px-20">
                        <div class="text-center">
                            <h1 class="h4 mb-8">Bevestig je email</h1>
                            <p class="mb-40">Mattis nunc sed blandit libero volutpat sed. Amet volutpat consequat mauris nunc congue nisi vitae</p>
                        </div>

                        <el-form class="mb-24" @submit="submit" :loading="loading" :success="success" :error="server_error" button-class="btn btn-green btn-lg btn-rounded w-full mt-8 font-bold" :submit-text="$t('forms.buttons.confirm_email')">
                            <el-input v-model="formData.email" :disabled="true" rules="required" :label="$t('forms.labels.email')" class="disabled mb-16"></el-input>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import hasForm from "@mixins/components/has-form";

export default {
    name: "Ui.EmailConfirm",

    mixins: [hasForm],

    props: {
        emailData: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            formData: {
                email: "",
                confirmation_token: ""
            }
        };
    },

    mounted() {
        this.formData.email = this.emailData.email;
        this.formData.confirmation_token = this.emailData.token;
        this.submit();
    },

    methods: {
        submit() {
            this.beforeSubmit();
            axios
                .post("/api/email-confirm", this.formData)
                .then(response => {
                    this.handleSuccess();
                    if (response && response.data && response.data.success) {
                        window.location.replace("/login?action=email-confirmed");
                    }
                })
                .catch(e => this.handleError(e.response.data));
        }
    }
};
</script>
